/**
 * Created by amirb on 12/18/14.
 */
define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var WidgetStateBase = require('web-agent-widgets/WidgetStateBase');
    var TasksManager = require('web-agent-lib/TasksManager');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var widgetConfig = require('web-agent-widgets/widgetConfig');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');

    var CustomWidget = WidgetStateBase.extend({
        ControllerName: 'CustomWidget',
        applicationType: 'CustomWidget',
        singleton: false,
        iframe: true,
        span: 2,


        LPViewMap: {
            iframe_tag: '.lpview_iframe_tag',
            tableItemsPlaceholder: ".lpview_table_items_placeholder",
            erroInfoLink: '.lpview_error_info_link',
            error_container: '.lpview_error_widget',
            error_fallback_error_link: '.lpview_error_fallback_error_link'

        },

    initialize: function (constructorData) {
        this.iframeView = this.getFirstElement(this.LPViewMap.iframe_tag);
        this.id = constructorData.id;
        this.baseURL = constructorData.url || '';
        this.description = constructorData.description || '';
        this.order = constructorData.order;
        //this.iframeView.src = 'about:blank';
        this.span = constructorData.span;
        this.applicationType = constructorData.applicationType;
        this.displayName = constructorData.displayName;
        this.visitInfoParam = constructorData.parameters;
        this.permissions = {
            viewChatTranscript: true,
            viewAuthenticatedData: true,
            viewSDEs: true,
            sendLines: true,
            directSendLines: false,
            getFileDownloadLink: false,
            sendSDEs: false,
            sendFile: privilegesController.hasSendFilesFromCustomWidgetPrivilege(),
        sendSC: true};
        this.mode = constructorData.mode;
        this.prohibitTranslation = true;
        this.setIcon(this);
        this.urlMaxLength = 2000;
        this.isIframeLoaded = false;
        this.iFrameLoaderTask = null;
        this.unBindState = true;
        this.timeoutBuffer = 1000;
        this.skillIds = constructorData.skillIds;

            // start state is loading.
            this.setState('loading');

            // remove the 'refresh' link that come from the base and enable the
            // new link for the errorLink
            this.lpHide(this.LPViewMap.refreshAction, this.LPViewMap.error_container);
            this.lpShow(this.LPViewMap.erroInfoLink, this.LPViewMap.error_container);
            if (this.configuration && this.configuration.config && this.configuration.config.fallbackUrl) {
                this.fallbackUrl = this.configuration.config.fallbackUrl;
            }

            if (this.configuration && this.configuration.config && this.configuration.config.fallbackUrlTimeout) {
                this.errorTimeout = this.configuration.config.fallbackUrlTimeout * 1000;
            }
        },

        events: function () {

            // the base class handle the 'state' event binding.
            this.bindEvents();

            this.bindViewEvent({selector: this.LPViewMap.erroInfoLink, DOMEvent: "click", callback: this.infoErrorLinkClicked});
            this.bindViewEvent({selector: '.lpview_error_fallback_link', DOMEvent: "click", callback: this.timeoutErrorLinkClicked});
        },

        render: function () {
            this.switchCustomWidgetMode();
            if (this.visitInfoParam && !this.visitInfoParam.length && typeof this.hidden !== 'undefined') {
                this.loadIFrame();
            }
        }
    });

    CustomWidget.prototype.onAssignedAgentChanged = function (data) {
        var newAgent, removedAgent, agentIdPropKey;

        data = data || {};
        newAgent = data.newValue;
        removedAgent = data.removedValue;

        // ignore side-effects of setting the agent-typing indication in the chat.agentInfo model path
        agentIdPropKey = this.getAgentIdPropKey();
        if ((newAgent && !newAgent[agentIdPropKey]) || (removedAgent && !removedAgent[agentIdPropKey])) {
            return;
        }

        this.setVisibility();
    };

    CustomWidget.prototype.getAgentIdPropKey = function () {
        var agentIdPropKey;
        if (this.isEngagementAsyncMessaging) {
            agentIdPropKey = 'messagingUserId';
        } else if (this.isEngagementRealTimeChat) {
            agentIdPropKey = 'agentId';
        }
        return agentIdPropKey;
    };

    CustomWidget.prototype.onAssignedAgentChanged = function (data) {
        var newAgent, removedAgent, agentIdPropKey;

        data = data || {};
        newAgent = data.newValue;
        removedAgent = data.removedValue;

        // ignore side-effects of setting the agent-typing indication in the chat.agentInfo model path
        agentIdPropKey = this.getAgentIdPropKey();
        if ((newAgent && !newAgent[agentIdPropKey]) || (removedAgent && !removedAgent[agentIdPropKey])) {
            return;
        }

        this.setVisibility();
    };

    CustomWidget.prototype.getAgentIdPropKey = function () {
        var agentIdPropKey;
        if (this.isEngagementAsyncMessaging) {
            agentIdPropKey = 'messagingUserId';
        } else if (this.isEngagementRealTimeChat) {
            agentIdPropKey = 'agentId';
        }
        return agentIdPropKey;
    };

    CustomWidget.prototype.onChatIdChanged = function (data) {
        // Add dispose protection, this method is called from derived/manager
        // components, so we are protecting this VC.
        if(this.disposed){
            return;
        }

        this.logger.debug('setting chat ID', 'onChatIdChanged', data);
        var chatId;
        var chatIds = Object.keys(data.newValue);
        for (var chat in chatIds) {
            chatId = chatIds[chat];
            if (chatId && this.chatId !== chatId) { // split session support
                this.onBeforeChatIdChanged();
                this.chatId = chatId;
                this.onAfterChatIdChanged();
            }
        }
    };

    CustomWidget.prototype.onBeforeChatIdChanged = function (data) {
        // abstract implementation (optional)
    };

    CustomWidget.prototype.onAfterChatIdChanged = function () {
        var assignedAgentModelPath;

        // cache the chat type to avoid redundant calls
        this.isEngagementAsyncMessaging = lpTag.WebAgent.logicController.isEngagementAsyncMessaging(this.chatId);
        this.isEngagementRealTimeChat = lpTag.WebAgent.logicController.isEngagementRealTimeChat(this.chatId);

        // listen to assigned agent changes to handle chat transfers
        assignedAgentModelPath = 'chats.' + this.chatId + '.agentInfo';

        // when chat is unassigned, there's no first trigger, cover that with an explicit call to set the initial state
        var assignedAgent = this.getModelParam(assignedAgentModelPath);
        if (!assignedAgent) {
            this.setVisibility();
        }

        this.unbindModel({
            modelPath: assignedAgentModelPath,
            callback: this.onAssignedAgentChanged,
            context: this
        });
        this.bindModel({
            modelPath: assignedAgentModelPath,
            callback: this.onAssignedAgentChanged,
            context: this
        });
    };

    CustomWidget.prototype.setVisibility = function () {
        this.hidden = !this.skillsMatchPredicate();
        this.isIframeLoaded = false;
        this.showWidget();
    };

    CustomWidget.prototype.skillsMatchPredicate = function () {
        var customWidgetSkillIds, agentSkillIds, engagementSkillIds;

        customWidgetSkillIds = lpTag.WebAgent.logicController.toStringTypedArray(this.skillIds);
        // no skills attached to the custom widget configuration, consider this a match
        if (!customWidgetSkillIds || !customWidgetSkillIds.length) {
            return true;
        }

        engagementSkillIds = lpTag.WebAgent.logicController.getEngagementSkillIdsByChatId(this.chatId);
        if (engagementSkillIds && engagementSkillIds.length) {
            // engagement is assigned to skill - return a match against the engagement's skills
            return !!_.intersection(engagementSkillIds, customWidgetSkillIds).length;
        } else {
            // engagement is unassigned - fallback to match against the agent's skills
            agentSkillIds = lpTag.WebAgent.logicController.getAgentSkillIdsByChatId(this.chatId);
            return !!_.intersection(agentSkillIds, customWidgetSkillIds).length;
        }
    };

    CustomWidget.prototype.getIFrameURL = function () {
        var flatConfig = widgetConfig.getInstance().getFlatWidgetConfig('visitInfo', false);

        var queryParams = [{
            name: 'lpHost',
            value: agentLEManager.getLEUrlResolverGetUrl('{liveEngage}')
        }];
        if (this.visitInfoParam && this.visitInfoParam.length) {
            var visitInfo = this.getModelParam("participants.info." + this.visitorId + ".data");
            if (visitInfo) {
                for (var i = 0; i < this.visitInfoParam.length; i++) {
                    var key = this.visitInfoParam[i].value;
                    if (key) {
                        queryParams.push({name: this.visitInfoParam[i].name, value: getPathValue(key, visitInfo, flatConfig)});
                    }
                }
            }
        }
        return lpUtils.getUrlWithParam(queryParams, this.baseURL);

        function getPathValue(key, dataModel) {
            var path = getFlatPathByKey(key, flatConfig);
            var retVal = '';
            var isValidPath = path !== '';
            var value = null;
            if (isValidPath) {
                // If we have a valid path - we should look within the data for the value
                value = widgetConfig.getInstance().compileFlatPath(path, dataModel);
            } else {
                // If we don't have a valid path - we should try to search for a custom variable with the given name
                value = getCustomVariable(key, dataModel);
            }
            var isInValidValue = (value === null || value === undefined || value === '--' || ( path === 'visitorName' && lpUtils.isIpAddress(value)));
            // if the value has a valid value;
            if (!isInValidValue) {
                retVal = value;
            }
            return retVal;

            function getCustomVariable(key, dataModel) {
                var customPath = 'customVariables';
                var searchData = {
                    searchFor: key,
                    searchIn: 'name',
                    returnValue: 'value'
                };
                var value = widgetConfig.getInstance().compileCustomArrayFlatPath(customPath, dataModel, searchData);
                if (value === null) {
                    // If we don't have a value - we should try to search for a custom variable with the given display name
                    searchData.searchIn = 'displayName';
                    value = widgetConfig.getInstance().compileCustomArrayFlatPath(customPath, dataModel, searchData);
                }
                return value;
            }
        }

        function getFlatPathByKey(key, config) {
            if (key && config) {
                for (var sectionIndex = 0; sectionIndex < config.length; sectionIndex++) {
                    var rows = config[sectionIndex] && config[sectionIndex].rows;
                    if (rows) {
                        for (var rowIndex = 0; rowIndex < rows.length; rowIndex++) {
                            var row = rows[rowIndex];
                            if (row && row.key && row.key === key && row.path) {
                                return row.path;
                            }
                        }
                    }
                }
            }
            return '';
        }
    };

    CustomWidget.prototype.getRootModelPath = function () {
        return "participants.info." + this.visitorId;
    };

    CustomWidget.prototype.infoErrorLinkClicked = function () {
        LE.crossModule("connection", LE.media.actions.command, LE.mediaCodes.connection.commands.showArticle, "iframe-integration-troubleshooting");
    };

    CustomWidget.prototype.timeoutErrorLinkClicked = function () {
        var fallbackUrl = this.configuration.config.fallbackUrl;
        window.open(fallbackUrl, '_blank');
        return false;
    };


    CustomWidget.prototype.setIcon = function () {
        var icon = document.createElement("button");
        this.addClass(icon, ['custom_widget_icon', 'grey']);
        icon.innerHTML = '<div class=\'custom_widget_icon_content\'>' + lpUtils.initialsFromString(this.displayName) + '</div>';
        this.setIconView(icon);
    };

    CustomWidget.prototype.iframeRefresh = function () {
        this.loadIFrame(true);
    };

    CustomWidget.prototype.getConfiguration = function () {
        var configuration = {
            rootModelPath: "participants.info." + this.visitorId,
            refreshCallback: this.iframeRefresh.bind(this),
            updateDataCallback: this.refreshClicked,
            textPrefix: 'custom_widget',
            templateFile: 'LP_iframe.html'
        };
        return configuration;
    };

    CustomWidget.prototype.dataStateChanged = function (data) {
// if we don't need params or the IFrame is already loaded, ignore the state change.
        if (!this.isIframeLoaded) {
            if (data) {
                var state = data.newValue;
                switch (state) {
                    case 'partial':
                    case 'success':
                    case 'error':
                        this.unbindEvents();
                        this.loadIFrame();
                        break;

                    case 'fetching':
                        break;
                    default:
                        break;
                }
            }
        }
    };

    CustomWidget.prototype.visitorFocused = function (eventData) {
        if (this.iFrameLoaderTask) {
            this.iFrameLoaderTask.priority = 1;
        }
        // Calling the parent..
        WidgetStateBase.prototype.visitorFocused.call(this, eventData);
    };

    CustomWidget.prototype.visitorBlurred = function (eventData) {
        if (this.iFrameLoaderTask) {

            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(this.visitorId);
            var eState = this.getModelParam(participantPath + '.participantState.engagementState');

            if (eState && eState == 'active') {
                this.iFrameLoaderTask.priority = 2;
            }
            else {
                this.iFrameLoaderTask.priority = 3;
            }

        }
        // Calling the parent..
        WidgetStateBase.prototype.visitorBlurred.call(this, eventData);
    };

    CustomWidget.prototype.setFallBackError = function () {
        this.logger.debug('setting fallback error', 'setFallBackError');
        if (this.fallbackUrl) {
            this.lpShow('.lpview_fallback_error', this.LPViewMap.error_container);
            this.setState('error');
        }

    };

    CustomWidget.prototype.loadIFrame = function (forceLoad) {
        var self = this;

        var url = this.getIFrameURL();

        // validating the length of the url
        if (!this.validateURLLength(url)) {
            this.setErrorMessage(this.translate('custom_widget_errorMessage_url_too_long'));
            this.setState('error');
            this.logger.error("URL TO LONG:" + url, 'validateURLLength');
            return;
        }

        // if the iFrame has loaded and we don't want to force load (refresh)
        // then cancel the operations.
        if (this.isIframeLoaded && !forceLoad) {
            return;
        }

        if (this.hidden) {
            return;
        }

        // if we are currently loading this widget, skip this...
        if (this.iFrameLoaderTask && this.iFrameLoaderTask.state === TasksManager.Task.TASK_STATES.RUNNING) {
            return;
        }

        // forcing the PENDING Task to run now.
        if (forceLoad && this.iFrameLoaderTask && this.iFrameLoaderTask.state === TasksManager.Task.TASK_STATES.PENDING) {
            this.widgetsManager.taskManager.forceStart(this.iFrameLoaderTask);
            return;
        }

        if (!this.iFrameLoaderTask || forceLoad) {
            var priority = forceLoad ? 0 : 3;

            // setting the task options:
            var taskOptions = {
                action: iFrameLoaderAction,
                priority: priority,
                callbacks: {
                    start: onTaskStart,
                    end: onTaskEnd,
                    error: onTaskError
                },
                timeout: this.errorTimeout ? this.errorTimeout + this.timeoutBuffer : null
            };
            this.iFrameLoaderTask = this.widgetsManager.taskManager.createAndAddTask(taskOptions);
        }

        // the Action to load the iFrame.
        function iFrameLoaderAction(done) {
            if (this.disposed) {
                done();
                return;
            }

        lpTag.WebAgent.iFrameManager.removeIFrame(self.visitorId, self.id);
        // add the listener of the Event:
        function onIFrameLoaded() {
            self.logger.info('iframe loaded called', 'onIFrameLoaded');
            self.isIframeLoaded = true;
            var iframeObj = {
                context : self,
                domain: lpUtils.getSubDomain(self.iframeView.src),
                callbacks : {
                    done:done,
                    setError:self.setFallBackError
                },
                permissions: {
                    read: {
                        chatTranscript: self.permissions.viewChatTranscript,
                        authenticatedData: self.permissions.viewAuthenticatedData,
                        SDE: self.permissions.viewSDEs
                    },
                    command: {
                        write: self.permissions.sendLines,
                        directWrite: self.permissions.directSendLines,
                        getFileDownloadLink: self.permissions.getFileDownloadLink,
                        sendSDE: self.permissions.sendSDEs,
                        sendFile: self.permissions.sendFile,
                    writeSC: self.permissions.sendSC}
                },
                fallbackTime:self.errorTimeout,
                fallbackUrl:self.fallbackUrl

                };
                lpTag.WebAgent.iFrameManager.addIFrame(iframeObj);
                if (!self.configuration.config || !self.configuration.config.fallbackUrl) {
                    done();
                }
            }

            // registering to the on load event, when the page finish loading.
            if (self.removeLoad) {
                self.removeLoad();
            }
            self.removeLoad = lpUtils.addEventListener(self.iframeView, 'load', onIFrameLoaded);
            // setting the 'src' attribute will start the loading of the page.
            self.iframeView.setAttribute('src', url);
        }

        function onTaskStart() {
            self.logger.debug('task started', 'onTaskStart');
            if (!self.disposed) {
                self.setState('loading');
                self.isIframeLoaded = false;
            }
        }

        function onTaskError(task, err) {
            self.logger.debug('task error: ' + {task: task, err: err}, 'onTaskError');
            if (!self.disposed) {
                self.iframeView.src = 'about:blank'; // stopping the iFrame loading process.
                self.setState('error');
                self.setErrorMessage(self.translate('custom_widget_errorMessage'));
                self.logger.error("IFrame load error:" + url + ' ::: ' + err && err.toString(), 'onTaskError');
            }
        }

        function onTaskEnd(task) {
            self.logger.debug('task ended: ' + task, 'onTaskEnd');
            if (!self.disposed) {
                self.iframeView.onload = null;  // removing the iFrame loading event.
                self.iFrameLoaderTask = null;   // disposing the task ref

                if (!task.error) {
                    self.setState('success');
                }
                self.logger.warn({msg: 'iFrame Loading Done Event', url: url, task: task, error: task.error && task.error.toString && task.error.toString() }, 'loadIFrame@@onTaskEnd');
            }
        }

    };

    CustomWidget.prototype.validateURLLength = function (url) {
        return (url.length <= this.urlMaxLength);
    };

    CustomWidget.prototype.switchCustomWidgetMode = function () {
        var widgetsContentAnimate = this.getFirstElement(".lpview_content_area_animate", this.configuration.widgetsManager.view);
        var placeHolderElement = this.getFirstElement("." + this.applicationType, widgetsContentAnimate);
        if (placeHolderElement && this.mode !== 'test') {
            this.removeClass(placeHolderElement, 'pilot_mode');
        } else {
            this.addClass(placeHolderElement, 'pilot_mode');
        }
    };


    CustomWidget.prototype.dispose = function () {

        // removing the loading from the task manager.
        if (this.iFrameLoaderTask) {
            this.widgetsManager.taskManager.removeTask(this.iFrameLoaderTask);
        }

        WidgetStateBase.prototype.dispose.call(this);
    };

    return CustomWidget;

});
